module.exports = __webpack_public_path__ + "img/5.1f6f4da1.png";